/* eslint-disable react/prop-types */
import React from 'react';
import cIf from 'classnames';
import PropTypes from 'prop-types';
import accounting from 'accounting';
import TranslatorManager from 'ts-translate-js';
import MarkDown from 'react-markdown';
import up from 'react-addons-update';
import moment from 'moment';
import * as _utilctl from './utilctl';
import tsRest from 'ts-rest-client';
import { map, find, sortBy, deburr, times, sumBy, round } from 'lodash';
import { PrepaidCardPanel } from './prepaidcardpanel';
import { trackEcommerceEvent } from '../js/client-tracking';


const tr = TranslatorManager.boundTR;

export const PaymentPanel =
class PaymentPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countries: [],
            showOtherCountryInput: false,
            selectedCountry: 0,
            trackCheckout: true,
            prepaidCards: [],
            showAddPrepaidCardPanel: false,
            addingPrepaidCard: false,
            prepaidCardError: null
        };

        this.cartTotal = 0;

        this.toggleAddPrepaidCardPanel = this.toggleAddPrepaidCardPanel.bind(this);
        this.handleAddPrepaidCard = this.handleAddPrepaidCard.bind(this);
        this.handleRemovePrepaidCard = this.handleRemovePrepaidCard.bind(this);
    }

    componentDidMount() {
        const trackingData = {
            type: 'checkout',
            currency: this.props.cart.CurrencyCode,
            items: map(this.props.cart.Items, item => {
                return {
                    name: item.Name,
                    quantity: item.Quantity,
                    price: item.Price,
                    category: item.EventCategoryFr, // Fix to french for reporting purposes
                    code: item.EventDateCode
                };
            })
        };
        trackEcommerceEvent(this.props.integ, trackingData);
        
        this.fetchCountries();
        this.fetchPrepaidCards();

        if (this.props.onContentChange !== undefined) {
            this.props.onContentChange();
        }
    }

    componentDidUpdate() {
        if (this.props.onContentChange !== undefined) {
            this.props.onContentChange();
        }
        
        const selectedCountry = find(this.state.countries, c => c.ID == this.state.selectedCountry);
        if (selectedCountry == undefined || selectedCountry.Name != this.props.paymentInfo.CardHolderCountry) {
            const selectedCountry = find(this.state.countries, c => c.Name == this.props.paymentInfo.CardHolderCountry);
            if (selectedCountry != undefined) {
                this.setState({ selectedCountry: selectedCountry.ID, showOtherCountryInput: false });
                this.handleOnChange("CardHolderCountry", { target: { value: selectedCountry.Name }} );
            }
        }
    }

    async fetchCountries() {
        try {
            let countries = await tsRest.get("/provincesbycountry/countries/internet/all");
            countries = sortBy(countries, c => deburr(c.Name));
            let selectedCountry = find(countries, c => c.Name == this.props.paymentInfo.CardHolderCountry);
            let newState = { countries: countries };
            if (selectedCountry != undefined)
                newState.selectedCountry = selectedCountry.ID;
            this.setState(newState);
        }
        catch(err) {
            console.log("fetchCountries error");
        }
    }

    async fetchPrepaidCards() {
        try {
            const prepaidCards = await tsRest.get("/session/current/cart/prepaidcards");
            this.setState({ prepaidCards: prepaidCards });
        }
        catch(err) {
            console.log("fetchPrepaidCards error");
        }
    }

    fillExpirationMonth(){
        const months = ["01","02","03","04","05","06","07","08","09","10","11","12"];
        return (months.map(function(month){
            return (<option key={month} className="text-center">{month}</option>);
        }.bind(this)));
    }

    fillExpirationYear(){
        let years = [], curYear;

        curYear = moment().year();

        times(15, (i) => years.push(curYear + i));

        return (years.map(function(year){
            return (<option key={year} className="text-center">{year}</option>);
        }.bind(this)));
    }

    getCardValidationControls() {
        if (this.props.addressValidationNeeded || this.props.postalCodeValidationNeeded) {
            const postalCodeCtl = this.props.postalCodeValidationNeeded ? <div className={cIf("col-md-2 col-sm-3 col-xs-4", { "col-sm-offset-3 col-md-offset-3" : this.props.addressValidationNeeded })}>
                <input className="form-control" value={this.props.paymentInfo.CardHolderPostalCode} onChange={this.handleOnChange.bind(this,"CardHolderPostalCode")} placeholder={tr("Code postal")} />
            </div> : null;

            const countriesCtl = <div className={cIf("col-md-3 col-sm-4 col-xs-4", { "col-sm-offset-3 col-md-offset-3" : this.props.addressValidationNeeded && !this.props.postalCodeValidationNeeded })}>
                {this.getCountryControl()}
            </div>;

            let addressCtl =  this.props.addressValidationNeeded ? <div className="col-md-3 col-sm-7 col-xs-8">
                <input className="form-control" value={this.props.paymentInfo.CardHolderAddress1} onChange={this.handleOnChange.bind(this,"CardHolderAddress1")} placeholder={tr("No civique et rue")} />
            </div>: null;

            const label = <label className="col-xs-12 col-sm-3 control-label left">{tr("Validation de la carte")}</label>;

            const addressCtrl = (this.props.addressValidationNeeded ?
                                 <div className="form-group">
                                     {label}
                                     {addressCtl}
                                 </div> :
                                 null);
            
            return <div>
                {addressCtrl}
                <div className="form-group">
                    {!this.props.addressValidationNeeded ? label : null}
                    {postalCodeCtl}
                    {countriesCtl}
                </div>
            </div>;
        }
        return null;
    }

    getCountriesDropdown() {
        let countries = (this.state.countries.map(function(country){
            return (<option key={country.ID} value={country.ID} className="text-center">{country.Name}</option>);
        }.bind(this)));

        countries.splice(0, 0, <option key={0} value={0} className="text-center">{tr("--- Sélectionner un pays ---")}</option>);
        countries.splice(1, 0, <option key={1} value={1} className="text-center">{tr("Autre")}</option>);

        return <select className="form-control" onChange={this.handleCountrySelection.bind(this)} value={this.state.selectedCountry}>
            {countries}
        </select>;
    }

    getCountryControl() {
        const selectCtl = this.getCountriesDropdown();

        if (this.state.showOtherCountryInput) {
            return <div>
                {selectCtl}
                <input type="text" className="form-control" placeholder={tr("Inscrire votre pays")} onChange={this.handleOnChange.bind(this, "CardHolderCountry")} />
            </div>;
        }
        return selectCtl;
    }

    getPaymentErrorMessage(){
        let retMessage = null;

        if (!this.props.transactionInProgress && this.props.orderPrepareResult != null && !this.props.orderPrepareResult.isSuccess)
        {
            let message = "";
            if (this.props.orderPrepareResult.deliveryMethodNotSet)
                message = tr("payment.completedelivery");
            else if (this.props.orderPrepareResult.invalidTicketNumberOrAmount)
                message = tr("payment.numberofitemshaschange");
            else if (this.props.orderPrepareResult.productNotInSale)
                message = tr("payment.itemsnotinsale") + this.props.orderPrepareResult.productsNotInSaleName;
            else if (this.props.orderPrepareResult.cartIsExpired)
                message = tr("payment.carthasexpired");
            else if (this.props.orderPrepareResult.acceptDisclaimers && this.props.orderPrepareResult.acceptPolicies)
                message = tr("Vous devez accepter les décharges de responsabilités et les politiques d'achats");
            else if (this.props.orderPrepareResult.acceptPolicies)
                message = tr("Vous devez accepter les politiques d'achats");
            else if (this.props.orderPrepareResult.acceptDisclaimers)
                message = tr("Vous devez accepter les décharges de responsabilités");
            else if (this.props.orderPrepareResult.missingAddress1)
                message = tr("Vous devrez entrer votre adresse de facturation");
            else if (this.props.orderPrepareResult.missingPostalCode)
                message = tr("Vous devez entrer le code postal de facturation");
            else if (this.props.orderPrepareResult.missingCountry)
                message = tr("Vous devez entrer le pays de facturation");
            else
                message = tr("payment.failedprocess");

            retMessage = <div className="form-group"><div className="alert alert-danger col-sm-8 text-center" role="alert">{message}</div></div>;
        }
        else if (this.props.orderProcessingResult != null &&this.props.orderProcessingResult.creditCardConditionNotMet)
            retMessage = <div className="form-group"><div className="alert alert-danger col-sm-8 text-center" role="alert"><MarkDown className="markdown-inline" source={tr("payment.creditcardconditionnotmet", {creditcard:this.props.orderProcessingResult.creditCardConditionName})} /></div></div>;
        else if (this.props.orderProcessingResult != null && !this.props.orderProcessingResult.isSuccess && this.props.orderProcessingResult.hasMessage)
            retMessage = <div className="form-group"><div className="alert alert-danger col-sm-8 text-center" role="alert">{this.props.orderProcessingResult.message}</div></div>;
        else if (this.props.orderProcessingResult != null && !this.props.orderProcessingResult.isSuccess && this.props.orderProcessingResult.redirectCheckoutError)
            retMessage = <div className="form-group"><div className="alert alert-danger col-sm-8 text-center" role="alert">{tr("Une erreur est survenue")}</div></div>;

        return retMessage;
    }

    handleOnChange(name, e){
        this.props.onChange(up(this.props.paymentInfo, { [ name ]: { $set: e.target.value } }));
    }

    handleCountrySelection(e) {
        if (e.target.value <= 1) { // "Other" or default option
            this.setState({ showOtherCountryInput: e.target.value == 1, selectedCountry: e.target.value});
            this.handleOnChange("CardHolderCountry", { target: { value: "" }} );
        }
        else {
            const selectedCountry = find(this.state.countries, c => c.ID == e.target.value);
            this.setState({ selectedCountry: selectedCountry.ID, showOtherCountryInput: false });
            this.handleOnChange("CardHolderCountry", { target: { value: selectedCountry.Name }} );
        }
    }

    handleCountryInputChange(e) {
        this.handleOnChange("CardHolderCountry", e);
    }

    handleCompleteTransaction(){
        this.props.onCompleteTransaction();
    }

    toggleAddPrepaidCardPanel() {
        this.setState({ showAddPrepaidCardPanel: !this.state.showAddPrepaidCardPanel, prepaidCardError: null });
    }

    handleAddPrepaidCard(number) {
        const alreadyInUse = find(this.state.prepaidCards, ['Number', number]);
        if (alreadyInUse) {
            this.setState({ prepaidCardError: this.getPrepaidCardErrorMessage({ body: { Message: "ALREADY_IN_USE" }}) });
            return;
        }
        this.setState({ addingPrepaidCard: true, prepaidCardError: null });
        this.addPrepaidCard(number);
    }

    async addPrepaidCard(number) {
        try {
            const result = await tsRest.post(`/session/current/cart/prepaidcards`, { number: number });
            this.setState({ 
                prepaidCards: result, prepaidCardError: null,
                addingPrepaidCard: false, showAddPrepaidCardPanel: false 
            });
        }
        catch(err) {
            this.setState({ addingPrepaidCard: false, prepaidCardError: this.getPrepaidCardErrorMessage(err) });
        }
    }

    async handleRemovePrepaidCard(cardId) {
        try {
            const prepaidCards = await tsRest.delete(`/session/current/cart/prepaidcards/${cardId}`);
            this.setState({ prepaidCards: prepaidCards });
        }
        catch(err){
            this.setState({ prepaidCardError: this.getPrepaidCardErrorMessage(err) });
        }
    }

    calculateTotalAmount() {
        const prepaidCardsTotalAmount = sumBy(this.state.prepaidCards, 'Balance');
        const total = round(this.props.cart.Total - prepaidCardsTotalAmount, 2);
        return total <= 0 ? 0 : total;
    }

    getPrepaidCardErrorMessage(error) {
        let errorMessage = tr("Une erreur est survenue. Veuillez réessayer plus tard.");

        if (error.status === 404)
            errorMessage = tr("Le numéro de carte est invalide."); 
        else if (error.body != undefined) {
            if (error.body.Message === "ALREADY_IN_USE")
                errorMessage = tr("Vous avez déjà entré cette carte cadeau.");
            else if (error.body.Message === "UNSUFFICIENT_AMOUNT")
                errorMessage = tr("Le montant de la carte cadeau entrée est insuffisant.");
            else if (error.body.Message === "INVALID_AMOUNT")
                errorMessage = tr("Le montant de la carte cadeau entrée est invalide.");
            else if (error.body.Message === "CARD_NOT_USABLE")
                errorMessage = tr("La carte n'est pas utilisable pour chacun des événements de votre panier.");
        }

        return errorMessage;
    }

    render(){
        const totalToPay = this.calculateTotalAmount();
        let processButtonSection;
        if(this.props.transactionInProgress) {
            processButtonSection = <div className="col-md-4 col-md-offset-1"><_utilctl.PleaseWaitSpinner size="md"/></div>;
        }
        else {
            let amountBadge = null;
            if (this.cartTotal > 0 || totalToPay > 0) amountBadge = <span className="badge">{accounting.formatMoney(totalToPay)}</span>;
            processButtonSection = <div className="col-sm-8">
                <button type="submit" className="btn btn-primary btn-lg"> <span className="glyphicon glyphicon-lock"></span> {tr("payment.completetransaction")} {amountBadge}</button>
            </div>;
        }
        let prepaidCardsPanel = null;
        if (this.props.canUsePrepaidCard) {
            prepaidCardsPanel = <PrepaidCardPanel 
                                    prepaidCards={this.state.prepaidCards} 
                                    cartTotal={this.props.cart.Total}
                                    errorMessage={this.state.prepaidCardError}
                                    showAddPrepaidCardPanel={this.state.showAddPrepaidCardPanel} 
                                    addingCard={this.state.addingPrepaidCard}
                                    onAddFormToggle={this.toggleAddPrepaidCardPanel}
                                    onRemoveCard={this.handleRemovePrepaidCard} 
                                    onAddCard={this.handleAddPrepaidCard} 
                                    onContentChange={this.props.onContentChange} 
            />;
        }

        let paymentPanel = null;
        if (!this.state.showAddPrepaidCardPanel) {
            // It it is a free transaction
            if (totalToPay == 0) {
                paymentPanel = <form className="form-horizontal" onSubmit={function(e) { e.preventDefault(); this.handleCompleteTransaction(); }.bind(this)}>
                    {this.getPaymentErrorMessage()}
                    <div className="form-group">
                        {processButtonSection}
                    </div>
                </form>;
            }
            else { // Else, normal purchase
                paymentPanel = <form className="form-horizontal" onSubmit={function(e) { e.preventDefault(); this.handleCompleteTransaction(); }.bind(this)}>

                    <div className="form-group">
                        <div className="col-sm-3">
                            <div className = "cardPaymentAvailable visa"></div>
                            <div className = "cardPaymentAvailable mastercard"></div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputCardHolderName" className="col-sm-3 control-label left">{tr("payment.cardholdername")}</label>
                        <div className="col-sm-3">
                            <input type="text" id="inputCardHolderName" className="form-control" maxLength={150} value={this.props.paymentInfo.CardHolderName} onChange={this.handleOnChange.bind(this,"CardHolderName")}></input>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputCardNumber" className="col-sm-3 control-label left">{tr("payment.cardnumber")}<p className="help-block">{tr("payment.cardnumberhelp")}</p></label>
                        <div className="col-sm-3">
                            <input type="text" id="inputCardNumber" className="form-control" maxLength={20} value={this.props.paymentInfo.CardNumber} onChange={this.handleOnChange.bind(this,"CardNumber")}></input>
                        </div>
                    </div>
                    <div className="form-group">
                        <label htmlFor="inputCVN" className="col-sm-3 col-xs-12 control-label left">{tr("payment.cardvalidationnumber")}<p className="help-block">{tr("payment.cvnhelp")}</p></label>
                        <div className="col-sm-1 col-xs-5">
                            <input type="text" id="inputCVN" className="form-control col-sm-1" maxLength={4} value={this.props.paymentInfo.CVNumber} onChange={this.handleOnChange.bind(this,"CVNumber")}></input>
                        </div>
                    </div>
                    <div className="form-group">
                        <label className="col-sm-3 control-label left">{tr("payment.expirationdate")}</label>
                        <div className="btn-toolbar col-sm-3">
                            <div className="btn-group">
                                <select className="form-control" value={this.props.paymentInfo.CardExpMonth} onChange={this.handleOnChange.bind(this,"CardExpMonth")}>
                                    {this.fillExpirationMonth()}
                                </select>
                            </div>
                            <div className="btn-group">
                                <select className="form-control" value={this.props.paymentInfo.CardExpYear} onChange={this.handleOnChange.bind(this,"CardExpYear")}>
                                    {this.fillExpirationYear()}
                                </select>
                            </div>
                        </div>
                    </div>
                    {this.getCardValidationControls()}
                    {this.getPaymentErrorMessage()}
                    <div className="form-group">
                        {processButtonSection}
                    </div>
                </form>;
            }
        }

        const threeDSChallengeMode = !!this.props.threeDSChallengeIframe;

        return <div className="well payment-container">
            <div className="form-horizontal">
                <div className="form-group">
                    <label className="col-xs-6 col-sm-3 left">{tr("Montant à payer")}</label>
                    <div className="col-xs-4 col-sm-2">
                        <div className="text-right amount">
                            <b>{accounting.formatMoney(this.props.cart.Total)}</b>
                        </div>
                    </div>
                </div>
                { this.props.cart.Total > 0 ? <hr /> : null }

                { threeDSChallengeMode && this.props.threeDSChallengeIframe }
                { !threeDSChallengeMode && prepaidCardsPanel }
                { !threeDSChallengeMode && paymentPanel }
            </div>
        </div>;
    }
};
PaymentPanel.propTypes = {
    cart: PropTypes.object,
    paymentInfo: PropTypes.shape({
        Method: PropTypes.string,
        CardHolderName : PropTypes.string,
        CardHolderPostalCode: PropTypes.string,
        CardHolderCountry: PropTypes.string,
        CardHolderAddress1: PropTypes.string,
        CardNumber : PropTypes.string,
        //CardValidationNumber: PropTypes.string,
        CVNumber : PropTypes.string,
        CardExpMonth : PropTypes.string,
        CardExpYear : PropTypes.number,
    }),
    orderProcessingResult: PropTypes.object,
    onChange: PropTypes.func,
    onContentChange: PropTypes.func,
    onCompleteTransaction: PropTypes.func,
    transactionInProgress: PropTypes.bool,
    addressValidationNeeded: PropTypes.bool,
    postalCodeValidationNeeded: PropTypes.bool,
    canUsePrepaidCard: PropTypes.bool,
    integ: PropTypes.string,
    threeDSChallengeIframe: PropTypes.element
};
